import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserSessionService } from 'src/app/shared/services/user-session.service';
import { switchMap, tap, catchError, finalize, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

	constructor(private userSessionService: UserSessionService,
		private authService: AuthService,
		private translate: TranslateService,
		private router: Router) {
	}

	ngOnInit() {
		this.authService.isAuthenticated().pipe(
			switchMap(() => this.authService.getCurrentUser().pipe(
				map(userResponse => {
					this.userSessionService.initializeUserSession(userResponse.body);
					const userLang = this.userSessionService.getLanguage();
					this.translate.use(userLang);
					return userResponse.body;
				}),
				catchError(() => of(null))
			)),
			catchError(() => {
				this.userSessionService.clearUserSession();
				return of(null);
			})
		).subscribe((res) => {
			if (res == null) {
				// No session. Keycloak hosts the login page, so hand off to it directly.
				this.authService.redirectToLogin();
				return;
			}

			this.router.navigate([this.userSessionService.getDefaultLandingPageByRole()]);
		});
	}

}
